<h1 class="title-modal-add-user" mat-dialog-title>
  <strong>Grouping functions</strong>
  <mat-icon (click)="onClose(false)">close</mat-icon>
</h1>
<mat-divider class="divider"></mat-divider>
<div class="testDisplay">
  <mat-form-field class="toto" appearance="fill" emptyPlaceholder="No data found">
    <mat-label>CSV</mat-label>
    <mat-select placeholder="Column type">
      @for (item of GroupTest?.importFileCsvs; track item.id) {
      <mat-option (click)="onAddElement(item)" value="{{ item.name }}">{{ item.name !== null ? item.name : 'toto' }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (GroupTest?.importFileXlsxes?.length !== 0) {
  <div>
    <mat-form-field class="toto" appearance="fill" emptyPlaceholder="No data found">
      <mat-label>Xslsx</mat-label>
      <mat-select placeholder="Column type">
        @for (item of GroupTest?.importFileXlsxes; track item.id) {
        <mat-option value="{{ item.name }}">{{ item.name !== null ? item.name : 'toto' }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  } @if (GroupTest?.tableVisualizations?.length !== 0) {
  <div>
    <mat-form-field class="toto" appearance="fill" emptyPlaceholder="No data found">
      <mat-label>Table</mat-label>
      <mat-select placeholder="Column type">
        @for (item of GroupTest?.tableVisualizations; track item.id) {
        <mat-option (click)="onAddElementTable(item)" value="{{ item.name }}">{{ item.name !== null ? item.name : 'toto' }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  }
</div>

<mat-divider class="divider"></mat-divider>
<form [formGroup]="groupElements" (ngSubmit)="onSubmit()">
  <mat-form-field fxFill appearance="fill">
    <mat-label>Name</mat-label>
    <input matInput id="name" formControlName="name" type="text" placeholder="Enter the name of the File" />
  </mat-form-field>
  <ul cdkDropList [cdkDropListData]="this.groupElements.value.groupElement" class="drop-area" (cdkDropListDropped)="drop($event)">
    <div formArrayName="groupElement">
      @for (item of groupElements.value.groupElement; track $index) {
      <div>
        <p class="drag-element" cdkDrag>
          {{ item.nameElement }} <span> <mic-icon class="icon-color" icon="drag_handle"></mic-icon></span>
          <span (click)="onDelete(item)"> <mic-icon class="icon-color" icon="delete"></mic-icon></span>
        </p>
      </div>
      }
    </div>
  </ul>
  <button mat-raised-button color="primary" type="submit" [disabled]="!groupElements.valid">Add group</button>
</form>
